import {
  DriverSnapshotOptions27dyx43p9jzht as DriverSnapshotOptions,
  ElementWithChildren23tv2h1ul7ktb as ElementWithChildren,
} from './Element.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { contains1tccixv8iwdcq as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { contains3ue2qo8xhmpf1 as contains_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function driverSnapshot(_this__u8e3s4, options) {
  options = options === VOID ? new (DriverSnapshotOptions())() : options;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var baseActions = setOf(['snapshot', 'screenshot', 'find', 'findClickable', 'scrollIntoView']);
  driverSnapshot$walk(options, this_0, baseActions, _this__u8e3s4, 0);
  return this_0.toString();
}
function parseSnapshotOptions(args) {
  return new (DriverSnapshotOptions())(contains(args, '--hidden'), contains(args, '--interactive'), contains(args, '--themes'));
}
function driverFind(_this__u8e3s4, query, includeHidden) {
  includeHidden = includeHidden === VOID ? false : includeHidden;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var baseActions = setOf(['snapshot', 'screenshot', 'find', 'findClickable', 'scrollIntoView']);
  // Inline function 'kotlin.collections.mutableListOf' call
  var results = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = driverChildren(_this__u8e3s4).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s.next_20eer_k$();
    driverFind$walk(includeHidden, query, results, baseActions, child, '');
  }
  if (results.isEmpty_y1axqb_k$()) {
    this_0.append_22ad7x_k$("No views matching '" + query + "'");
  } else {
    var _iterator__ex2g4s_0 = results.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.next_20eer_k$();
      var path = _destruct__k2r9zo.component1_7eebsc_k$();
      var view = _destruct__k2r9zo.component2_7eebsb_k$();
      // Inline function 'kotlin.text.appendLine' call
      var value = path + ': ' + view.driverDisplay_abwxi1_k$(new (DriverSnapshotOptions())());
      // Inline function 'kotlin.text.appendLine' call
      this_0.append_22ad7x_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
    }
  }
  return this_0.toString();
}
function driverFindClickable(_this__u8e3s4, query, includeHidden) {
  includeHidden = includeHidden === VOID ? false : includeHidden;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var baseActions = setOf(['snapshot', 'screenshot', 'find', 'findClickable', 'scrollIntoView']);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var viewPaths = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var matches = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = driverChildren(_this__u8e3s4).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s.next_20eer_k$();
    driverFindClickable$walk(includeHidden, query, viewPaths, matches, baseActions, child, '');
  }
  // Inline function 'kotlin.collections.mutableSetOf' call
  var seen = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var results = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = matches.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var match = _iterator__ex2g4s_0.next_20eer_k$();
    var current = match;
    $l$loop_1: while (true) {
      var tmp;
      if (!(current == null)) {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var key = current;
        tmp = (isInterface(viewPaths, KtMap()) ? viewPaths : THROW_CCE()).containsKey_aw81wo_k$(key);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop_1;
      }
      if (current.get_driverActions_8jqr2k_k$().containsKey_aw81wo_k$('click')) {
        if (seen.add_utx5q5_k$(current)) {
          var tmp0_elvis_lhs = viewPaths.get_wei43m_k$(current);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            break $l$loop_1;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var path = tmp_0;
          results.add_utx5q5_k$(to(path, current));
        }
        break $l$loop_1;
      }
      current = current.get_parent_hy4reb_k$();
    }
  }
  if (results.isEmpty_y1axqb_k$()) {
    this_0.append_22ad7x_k$("No clickable views matching '" + query + "'");
  } else {
    var _iterator__ex2g4s_1 = results.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_1.next_20eer_k$();
      var path_0 = _destruct__k2r9zo.component1_7eebsc_k$();
      var view = _destruct__k2r9zo.component2_7eebsb_k$();
      // Inline function 'kotlin.text.appendLine' call
      var value = path_0 + ': ' + view.driverDisplay_abwxi1_k$(new (DriverSnapshotOptions())());
      // Inline function 'kotlin.text.appendLine' call
      this_0.append_22ad7x_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
    }
  }
  return this_0.toString();
}
function driverChildren(_this__u8e3s4) {
  var tmp0_safe_receiver = isInterface(_this__u8e3s4, ElementWithChildren()) ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_children_4cwbp4_k$();
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function driverSnapshot$walk($options, $this_buildString, baseActions, view, depth) {
  if (!$options.includeHidden_1 && !(view.get_shown_iyiju0_k$() && view.get_visible_8zfvk9_k$()))
    return Unit_instance;
  var line = view.get_underlyingNativeElement_vngz33_k$().driverDisplay_abwxi1_k$($options);
  var tmp;
  var tmp_0;
  var tmp_1;
  if ($options.interactiveOnly_1) {
    var tmp0 = view.get_driverActions_8jqr2k_k$().get_keys_wop4xp_k$();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_2;
      if (isInterface(tmp0, Collection())) {
        tmp_2 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (!baseActions.contains_aljjnj_k$(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp_1 = tmp$ret$0;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = view.get_driverValue_yh5neo_k$() == null;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = view.get_debugName_58dolx_k$() == null;
  } else {
    tmp = false;
  }
  if (tmp) {
    var _iterator__ex2g4s_0 = driverChildren(view).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var child = _iterator__ex2g4s_0.next_20eer_k$();
      driverSnapshot$walk($options, $this_buildString, baseActions, child, depth);
    }
    return Unit_instance;
  }
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < depth)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      $this_buildString.append_22ad7x_k$('  ');
    }
     while (inductionVariable < depth);
  // Inline function 'kotlin.text.appendLine' call
  // Inline function 'kotlin.text.appendLine' call
  $this_buildString.append_22ad7x_k$(line).append_58al37_k$(_Char___init__impl__6a9atx(10));
  var _iterator__ex2g4s_1 = driverChildren(view).iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var child_0 = _iterator__ex2g4s_1.next_20eer_k$();
    driverSnapshot$walk($options, $this_buildString, baseActions, child_0, depth + 1 | 0);
  }
}
function driverFind$walk($includeHidden, $query, results, baseActions, view, pathPrefix) {
  if (!$includeHidden && !(view.get_shown_iyiju0_k$() && view.get_visible_8zfvk9_k$()))
    return Unit_instance;
  var tmp0_elvis_lhs = view.get_debugName_58dolx_k$();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = view.get_parent_hy4reb_k$();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_children_4cwbp4_k$();
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.indexOf_si1fv9_k$(view);
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      if (tmp3_safe_receiver >= 0) {
        tmp_1 = tmp3_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp4_safe_receiver = tmp_0;
    tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.toString();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp5_elvis_lhs = tmp;
  var segment = tmp5_elvis_lhs == null ? '0' : tmp5_elvis_lhs;
  var tmp_2;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(pathPrefix) === 0) {
    tmp_3 = true;
  } else {
    tmp_3 = toIntOrNull(segment) == null;
  }
  if (tmp_3) {
    tmp_2 = segment;
  } else {
    tmp_2 = pathPrefix + '/' + segment;
  }
  var path = tmp_2;
  var tmp6_safe_receiver = view.get_debugName_58dolx_k$();
  var nameMatch = (tmp6_safe_receiver == null ? null : contains_0(tmp6_safe_receiver, $query, true)) === true;
  var tmp7_safe_receiver = view.get_driverValue_yh5neo_k$();
  var valueMatch = (tmp7_safe_receiver == null ? null : contains_0(tmp7_safe_receiver, $query, true)) === true;
  var tmp8_safe_receiver = getKClassFromExpression(view).get_simpleName_r6f8py_k$();
  var typeMatch = (tmp8_safe_receiver == null ? null : contains_0(tmp8_safe_receiver, $query, true)) === true;
  var tmp0 = view.get_driverActions_8jqr2k_k$().get_keys_wop4xp_k$();
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_4;
    if (isInterface(tmp0, Collection())) {
      tmp_4 = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp$ret$3 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (!baseActions.contains_aljjnj_k$(element) && contains_0(element, $query, true)) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
    }
    tmp$ret$3 = false;
  }
  var actionMatch = tmp$ret$3;
  if (nameMatch || valueMatch || typeMatch || actionMatch) {
    results.add_utx5q5_k$(to(path, view));
  }
  var _iterator__ex2g4s_0 = driverChildren(view).iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s_0.next_20eer_k$();
    driverFind$walk($includeHidden, $query, results, baseActions, child, path);
  }
}
function driverFindClickable$walk($includeHidden, $query, viewPaths, matches, baseActions, view, pathPrefix) {
  if (!$includeHidden && !(view.get_shown_iyiju0_k$() && view.get_visible_8zfvk9_k$()))
    return Unit_instance;
  var tmp0_elvis_lhs = view.get_debugName_58dolx_k$();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = view.get_parent_hy4reb_k$();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_children_4cwbp4_k$();
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.indexOf_si1fv9_k$(view);
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      if (tmp3_safe_receiver >= 0) {
        tmp_1 = tmp3_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp4_safe_receiver = tmp_0;
    tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.toString();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp5_elvis_lhs = tmp;
  var segment = tmp5_elvis_lhs == null ? '0' : tmp5_elvis_lhs;
  var tmp_2;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(pathPrefix) === 0) {
    tmp_3 = true;
  } else {
    tmp_3 = toIntOrNull(segment) == null;
  }
  if (tmp_3) {
    tmp_2 = segment;
  } else {
    tmp_2 = pathPrefix + '/' + segment;
  }
  var path = tmp_2;
  // Inline function 'kotlin.collections.set' call
  viewPaths.put_4fpzoq_k$(view, path);
  var tmp6_safe_receiver = view.get_debugName_58dolx_k$();
  var nameMatch = (tmp6_safe_receiver == null ? null : contains_0(tmp6_safe_receiver, $query, true)) === true;
  var tmp7_safe_receiver = view.get_driverValue_yh5neo_k$();
  var valueMatch = (tmp7_safe_receiver == null ? null : contains_0(tmp7_safe_receiver, $query, true)) === true;
  var tmp8_safe_receiver = getKClassFromExpression(view).get_simpleName_r6f8py_k$();
  var typeMatch = (tmp8_safe_receiver == null ? null : contains_0(tmp8_safe_receiver, $query, true)) === true;
  var tmp0 = view.get_driverActions_8jqr2k_k$().get_keys_wop4xp_k$();
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_4;
    if (isInterface(tmp0, Collection())) {
      tmp_4 = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp$ret$4 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (!baseActions.contains_aljjnj_k$(element) && contains_0(element, $query, true)) {
        tmp$ret$4 = true;
        break $l$block_0;
      }
    }
    tmp$ret$4 = false;
  }
  var actionMatch = tmp$ret$4;
  if (nameMatch || valueMatch || typeMatch || actionMatch) {
    matches.add_utx5q5_k$(view);
  }
  var _iterator__ex2g4s_0 = driverChildren(view).iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s_0.next_20eer_k$();
    driverFindClickable$walk($includeHidden, $query, viewPaths, matches, baseActions, child, path);
  }
}
//region block: exports
export {
  driverChildren as driverChildren2ahybtnb3gaha,
  driverFindClickable as driverFindClickable2yf0q7fq9llcj,
  driverFind as driverFind3c0cv7qtsjjqg,
  driverSnapshot as driverSnapshot8nzyivxk5zsq,
  parseSnapshotOptions as parseSnapshotOptions920tt8z7mdfy,
};
//endregion

//# sourceMappingURL=DriverSupport.mjs.map
